import type { CreateRegistrationSessionResult } from "@/domain/model/Registration";
import type { RegistrationStore } from "@/domain/port/RegistrationStore";
import type { SessionStore } from "@/domain/port/SessionStore";

export class CompleteRegistrationAuthentication {
  constructor(
    private readonly sessionStore: SessionStore,
    private readonly registrationStore: RegistrationStore,
  ) {}

  execute(session: CreateRegistrationSessionResult): void {
    this.sessionStore.set({
      accessToken: session.accessToken,
      accessExpiresAt: session.accessExpiresAt,
    });

    this.registrationStore.clearRegistrationDraft();
    this.registrationStore.clearLatestAttempt();
  }
}
